import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetServiceModuleExpensesColumnChartValuesResultType,
    GetServiceModuleExpensesLineChartValuesResultType,
    GetServiceModuleExpensesMetricsValuesResultType,
    GetServiceModuleExpensesValuesResultType,
    ReportResultColumnDto,
    ServiceExpensesClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ServiceExpensesService extends CustomReportServiceBase<ServiceExpensesClient, CustomReportServiceView> {
    constructor(protected override client: ServiceExpensesClient) {
        super(client);
    }

    async getValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceModuleExpensesValuesResultType[]> {
        return await lastValueFrom(this.client.serviceExpensesGetServiceModuleExpensesValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.serviceExpensesGetServiceModuleExpensesBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceModuleExpensesColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.serviceExpensesGetServiceModuleExpensesColumnChartValues(parameters));
    }

    async getMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceModuleExpensesMetricsValuesResultType> {
        return await lastValueFrom(this.client.serviceExpensesGetServiceModuleExpensesMetricsValues(parameters));
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceModuleExpensesLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.serviceExpensesGetServiceModuleExpensesLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.serviceExpensesSaveCatalogReport(body));
        else return await lastValueFrom(this.client.serviceExpensesSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceExpensesGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.serviceExpensesCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceExpensesGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.serviceExpensesResultAvailableColumns(organizationIds));
    }
}
